//import { cn } from '@fullcalendar/core/internal-common'
import IonIcon from '@reacticons/ionicons'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { MouseEvent, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import * as enVariables from 'src/config/config'
import { INSIGHTS_MENU, LTH_SOLUTION_MENU } from 'src/constants/constants'
import { ISubTopicItemFragment, ITopicItemFragment } from 'src/graphql/generated/hooks'
import {
  useGetShareableContentsLazyQuery,
  useMySharedContentsLazyQuery,
  useSolutionsForVendorLazyQuery,
} from 'src/graphql/generated/hooks'
import { useAuthenticated } from 'src/hooks/useAuthenticated'
import { AppState } from 'src/store/types'

import { CompatibleLink } from '../CompatibleLink/CompatibleLink'
// import { VendorState } from '../EditListing/VendorStateModal'
//import { CompatibleLink } from '../CompatibleLink/CompatibleLink'
import { LabelLink } from './LabelLink'

export interface SlidingbarProps {
  className?: string
  topics: ITopicItemFragment[]
  options: MenuItem[]
  onClosePanel: () => void
  onSignout: () => void
  onSelectMenu: (title: string) => void
  onShowPremiumModal: () => void // Add this prop
  isPanelClosing?: boolean // Add this prop to track panel closing state
  setShowVendorState: (item: boolean) => void
}

export interface MenuItem {
  title: string
  subMenuContained: boolean
}

export const Slidingbar: React.FC<SlidingbarProps> = ({
  options,
  topics,
  onSignout,
  onClosePanel,
  onShowPremiumModal,
  // isPanelClosing = false, // Add this prop
  setShowVendorState,
}) => {
  const router = useRouter()
  const authInfo = useSelector((state: AppState) => state.authInfo)
  const [loadData, { data }] = useSolutionsForVendorLazyQuery()
  const [solutionsCount, setSolutionsCount] = useState(0)
  const [isEnhanced, setIsEnhanced] = useState(false)
  const [loadContents, { data: contentsData }] = useGetShareableContentsLazyQuery()
  const [loadSharedContents, { data: sharedContentsData }] = useMySharedContentsLazyQuery()
  const [isResourceExist, setIsResourceExist] = useState(false)
  const [isSharedResourceExist, setIsSharedResourceExist] = useState(false)

  const [selectedMenu, setSelectedMenu] = useState('')
  const [selectedTopic, setSelectedTopic] = useState('')
  const [selectedTopicSlug, setSelectedTopicSlug] = useState('')
  const [selectedSubTopics, setSelectedSubTopics] = useState<ISubTopicItemFragment[]>([])
  const lthSolutionMenu = LTH_SOLUTION_MENU
  const lthInsightsMenu = INSIGHTS_MENU
  const { isPremium } = useAuthenticated()
  // Remove the showModal state since it's now handled in Header
  // const [showModal, setShowModal] = useState(false)

  // Add useEffect to load vendor solutions data
  useEffect(() => {
    if (authInfo.idToken && authInfo.idToken !== '') {
      loadData({
        variables: {
          query: {
            offset: 0,
            limit: 1000,
          },
        },
      })
    }
  }, [authInfo.idToken, loadData])

  // Add useEffect to set solutions count
  useEffect(() => {
    if (data?.searchVendorSolutions.solutions) {
      setSolutionsCount(data.searchVendorSolutions.solutions.length)
      data.searchVendorSolutions.solutions.map((item) => {
        if (item?.isEnhanced) {
          setIsEnhanced(true)
        }
      })
    }
  }, [data])

  // Add useEffect to check for resources
  useEffect(() => {
    if (authInfo.idToken && authInfo.idToken !== '') {
      const tempQuery = {
        subTopicIds: '',
        contentType: '',
      }
      loadContents({ variables: { offset: 0, limit: 1, query: tempQuery } })
      loadSharedContents({ variables: { offset: 0, limit: 1, query: tempQuery } })
    }
  }, [authInfo.idToken, loadContents, loadSharedContents])

  useEffect(() => {
    if (contentsData) {
      const total = contentsData?.shareableContents?.total || 0
      if (total > 0) {
        setIsResourceExist(true)
      }
    }
  }, [contentsData])

  useEffect(() => {
    if (sharedContentsData) {
      const total = sharedContentsData?.mySharedContents?.total || 0
      if (total > 0) {
        setIsSharedResourceExist(true)
      }
    }
  }, [sharedContentsData])

  const handleSelectMenu = (e: MouseEvent<HTMLDivElement>, title: string) => {
    /* if (title === 'Events') {
      router.push({ pathname: '/events' })
    } else */ if (title === 'About Us') {
      router.push({ pathname: '/about' })
    } else if (title?.toLocaleLowerCase() === 'Legaltech Jobs'.toLocaleLowerCase()) {
      window.open(enVariables.JOB_URL)
    } else if (title === 'Sign In') {
      router.push({ pathname: '/signin' })
    } else if (title === 'Sign Up') {
      router.push({ pathname: '/registration' })
    } else {
      setSelectedMenu(title)
    }
  }

  const handleSignoutAndRedirect = () => {
    onSignout()
  }

  const handleMenuBack = () => {
    // If VendorState modal is open, close it first
    /* if (showVendorState) {
      setShowVendorState(false)
      onClosePanel()
      return
    } */

    // Otherwise, handle normal menu back navigation
    if (selectedTopic === '') {
      setSelectedMenu('')
    } else {
      setSelectedTopic('')
    }
  }

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (!isPremium) {
      e.preventDefault() // Prevent the navigation
      e.stopPropagation()
      onClosePanel()
      onShowPremiumModal() // Call the callback to show modal in Header
      onClosePanel() // Close the panel
    }
  }

  // Remove handleCloseModal since it's no longer needed here

  // Add state for vendor state modal
  //const [showVendorState, setShowVendorState] = useState(false)

  // Add useEffect to close VendorState modal when panel is closing
  // useEffect(() => {
  //   if (isPanelClosing && showVendorState) {
  //     setShowVendorState(false)
  //   }
  // }, [isPanelClosing, showVendorState])

  const handleClosePanel = () => {
    // Close VendorState modal first if it's open
    /*   if (showVendorState) {
        setShowVendorState(false)
      } */
    // Then close the panel
    onClosePanel()
  }

  return (
    <div style={{ backgroundColor: '#011d58', height: '100%', zIndex: '10000' }}>
      <div className="flex flex-col p-[1.5625rem]" style={{ backgroundColor: '#011d58' }}>
        {selectedMenu === '' && (
          <div className="flex flex-col w-full" style={{ backgroundColor: '#011d58' }}>
            <div className="flex ml-auto" onClick={handleClosePanel}>
              <IonIcon name="close-outline" className="!h-[30px] !w-[30px] text-[white]" />
            </div>
            <hr className="mt-[1.87652rem]" style={{ opacity: '0.3' }} />
            {options.map((option: MenuItem, index: number) => {
              return (
                <div key={index} onClick={(e: MouseEvent<HTMLDivElement>) => handleSelectMenu(e, option.title)}>
                  <div className="flex flex-row h-[2.5rem] items-center">
                    <p className="text-[white] font-secondary text-[0.875rem]">{option.title}</p>
                    {option.subMenuContained && (
                      <IonIcon name="chevron-forward-outline" className="!w-[20px] !h-[20px] ml-auto text-[white]" />
                    )}
                  </div>
                  <hr className="" style={{ opacity: '0.3' }} />
                </div>
              )
            })}
          </div>
        )}

        {selectedMenu === 'Topics' && (
          <div style={{ backgroundColor: '#011d58' }}>
            <div className="flex flex-row">
              <div className="flex flex-col">
                <div className="flex flex-row items-center" onClick={handleMenuBack}>
                  <IonIcon name="chevron-back-outline" className="!w-[20px] !h-[20px] text-[white]" />
                  <p className="text-[white] font-secondary text-[0.75rem] cursor-pointer">Back</p>
                </div>
                <p className="text-[white] font-secondary font-bold text-[0.875rem] mt-[1.2875rem]">
                  {selectedTopic === '' ? 'TOPICS' : selectedTopic}
                </p>
              </div>

              <div className="flex ml-auto" onClick={handleClosePanel}>
                <IonIcon name="close-outline" className="!h-[30px] !w-[30px] text-[white] cursor-pointer" />
              </div>
            </div>

            <hr className="mt-[0.87652rem]" style={{ opacity: '0.3' }} />
            {selectedTopic === '' ? (
              topics.map((topic, index) => {
                return (
                  <div className="flex flex-col w-full" key={index}>
                    <div className="flex flex-row h-[2.5rem]">
                      <CompatibleLink href={'/topics/' + topic?.slug} className="flex items-center w-full">
                        <IonIcon
                          // eslint-disable-next-line @typescript-eslint/no-explicit-any
                          name={topic?.iconName as any}
                          className="!w-[20px] !h-[20px] text-[white] mr-[0.875rem]"
                        />
                        <p className="text-[white] font-secondary text-[0.875rem]">{topic?.name}</p>
                        <div
                          className="ml-auto w-[60px] h-[40px] flex items-center justify-end"
                          onClick={() => {
                            setSelectedTopic(topic?.name || '')
                            setSelectedTopicSlug(topic?.slug || '')
                            setSelectedSubTopics(
                              (topic?.subTopics || []).filter((s): s is ISubTopicItemFragment => s !== null),
                            )
                          }}
                        >
                          <IonIcon name="chevron-forward-outline" className="!w-[20px] !h-[20px] text-[white]" />
                        </div>
                      </CompatibleLink>
                    </div>
                    <hr style={{ opacity: '0.3' }} />
                  </div>
                )
              })
            ) : (
              <>
                {selectedSubTopics.map((topic, index) => {
                  return (
                    <div className="flex flex-col w-full" key={index}>
                      <div className="flex flex-row h-[2.5rem] items-center">
                        <Link href={`/topics/${selectedTopicSlug}/${topic?.slug}`} className="flex flex-row w-full">
                          <p className="text-[white] font-secondary text-[0.875rem]">{topic?.name}</p>
                        </Link>
                      </div>
                      <hr style={{ opacity: '0.3' }} />
                    </div>
                  )
                })}
                <div className="flex flex-col w-full">
                  <div className="flex flex-row h-[2.5rem] items-center">
                    <Link
                      href={`/topics/${selectedTopicSlug}`}
                      className="flex flex-row w-full text-[white] font-secondary text-[0.875rem]"
                    >
                      View All
                    </Link>
                  </div>
                  <hr style={{ opacity: '0.3' }} />
                </div>
              </>
            )}
          </div>
        )}
        {selectedMenu === 'LTH Solutions' && (
          <div style={{ backgroundColor: '#011d58' }}>
            <div className="flex flex-row">
              <div className="flex flex-col">
                <div className="flex flex-row items-center" onClick={handleMenuBack}>
                  <IonIcon name="chevron-back-outline" className="!w-[20px] !h-[20px] text-[white]" />
                  <p className="text-[white] font-secondary text-[0.75rem] cursor-pointer">Back</p>
                </div>
                <p className="text-[white] font-secondary font-bold text-[0.875rem] mt-[1.2875rem]">LTH Solutions</p>
              </div>

              <div className="flex ml-auto" onClick={handleClosePanel}>
                <IonIcon name="close-outline" className="!h-[30px] !w-[30px] text-[white] cursor-pointer" />
              </div>
            </div>

            <hr className="mt-[0.87652rem]" style={{ opacity: '0.3' }} />

            {lthSolutionMenu &&
              lthSolutionMenu.map((item: { slg: string; title: string }, index: number) => {
                return (
                  <div className="flex flex-col w-full" key={index}>
                    <div className="flex flex-row h-[2.5rem] items-center">
                      <LabelLink
                        key={'solution-' + index}
                        href={item?.slg}
                        label={item?.title}
                        className="text-[white] font-secondary text-[0.875rem]"
                        onClick={handleClosePanel}
                      />
                    </div>
                    <hr style={{ opacity: '0.3' }} />
                  </div>
                )
              })}

            <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] items-center">
                <Link
                  href={enVariables.JOB_URL}
                  passHref
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[white] font-secondary text-[0.875rem]"
                >
                  {/* Legal<span className="text-turquoise">tech </span>&nbsp;Jobs */}
                  Legaltech Jobs
                </Link>
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div>
          </div>
        )}
        {selectedMenu === 'Insights' && (
          <div style={{ backgroundColor: '#011d58' }}>
            <div className="flex flex-row">
              <div className="flex flex-col">
                <div className="flex flex-row items-center" onClick={handleMenuBack}>
                  <IonIcon name="chevron-back-outline" className="!w-[20px] !h-[20px] text-[white]" />
                  <p className="text-[white] font-secondary text-[0.75rem] cursor-pointer">Back</p>
                </div>
                <p className="text-[white] font-secondary font-bold text-[0.875rem] mt-[1.2875rem]">Insights</p>
              </div>

              <div className="flex ml-auto" onClick={handleClosePanel}>
                <IonIcon name="close-outline" className="!h-[30px] !w-[30px] text-[white] cursor-pointer" />
              </div>
            </div>

            <hr className="mt-[0.87652rem]" style={{ opacity: '0.3' }} />

            {lthInsightsMenu &&
              lthInsightsMenu.map((item: { slg: string; title: string }, index: number) => {
                return (
                  <div className="flex flex-col w-full" key={index}>
                    <div className="flex flex-row h-[2.5rem] items-center">
                      <LabelLink
                        key={'insight-' + index}
                        href={item?.slg}
                        label={item?.title}
                        className="text-[white] font-secondary text-[0.875rem]"
                        onClick={handleClosePanel}
                      />
                    </div>
                    <hr style={{ opacity: '0.3' }} />
                  </div>
                )
              })}
          </div>
        )}
        {selectedMenu === 'Events' && (
          <div style={{ backgroundColor: '#011d58' }}>
            <div className="flex flex-row">
              <div className="flex flex-col">
                <div className="flex flex-row items-center" onClick={handleMenuBack}>
                  <IonIcon name="chevron-back-outline" className="!w-[20px] !h-[20px] text-[white]" />
                  <p className="text-[white] font-secondary text-[0.75rem] cursor-pointer">Back</p>
                </div>
                <p className="text-[white] font-secondary font-bold text-[0.875rem] mt-[1.2875rem]">Events</p>
              </div>

              <div className="flex ml-auto" onClick={handleClosePanel}>
                <IonIcon name="close-outline" className="!h-[30px] !w-[30px] text-[white] cursor-pointer" />
              </div>
            </div>

            <hr className="mt-[0.87652rem]" style={{ opacity: '0.3' }} />

            <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] items-center">
                <LabelLink
                  href="https://lthconferences.legaltechnologyhub.com"
                  label="LTH Events"
                  className="text-[white] font-secondary text-[0.875rem]"
                  onClick={handleClosePanel}
                />
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div>
            <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] items-center">
                <LabelLink
                  href="/events/"
                  label="Events Calendar"
                  className="text-[white] font-secondary text-[0.875rem]"
                  onClick={handleClosePanel}
                />
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div>
          </div>
        )}

        {selectedMenu === 'My Account' && (
          <div style={{ backgroundColor: '#011d58' }}>
            <div className="flex flex-row">
              <div className="flex flex-col">
                <div className="flex flex-row items-center" onClick={handleMenuBack}>
                  <IonIcon name="chevron-back-outline" className="!w-[20px] !h-[20px] text-[white]" />
                  <p className="text-[white] font-secondary text-[0.75rem] cursor-pointer">Back</p>
                </div>
                <p className="text-[white] font-secondary font-bold text-[0.875rem] mt-[1.2875rem]">{selectedTopic}</p>
              </div>

              <div className="flex ml-auto" onClick={handleClosePanel}>
                <IonIcon name="close-outline" className="!h-[30px] !w-[30px] text-[white] cursor-pointer" />
              </div>
            </div>

            <hr className="mt-[0.87652rem]" style={{ opacity: '0.3' }} />
            {/* Add conditional logic for vendor solutions */}
            {authInfo.isVendor &&
              authInfo?.vendor != '' &&
              authInfo?.vendor != null &&
              (solutionsCount > 0 && authInfo.publishedAt !== null ? (
                <div className="flex flex-col w-full">
                  <div className="flex flex-row h-[2.5rem] items-center">
                    <LabelLink
                      href="/my-solutions"
                      label="Manage Solutions"
                      className="text-[white] font-secondary text-[0.875rem]"
                      onClick={(e) => {
                        if (data && authInfo.publishedAt === '') {
                          e.preventDefault()
                          e.stopPropagation()
                          onClosePanel()
                          setShowVendorState?.(true) // Show Request Access popup
                        }
                      }}
                    />
                  </div>
                  <hr style={{ opacity: '0.3' }} />
                </div>
              ) : (
                <div className="flex flex-col w-full">
                  <div className="flex flex-row h-[2.5rem] items-center">
                    <LabelLink
                      href="/create-new-solution"
                      label="Add Solution"
                      className="text-[white] font-secondary text-[0.875rem]"
                      onClick={(e) => {
                        if (data && authInfo.publishedAt === '') {
                          e.preventDefault()
                          e.stopPropagation()
                          onClosePanel()
                          setShowVendorState?.(true) // Show Request Access popup
                        } else {
                          router.push('/create-new-solution')
                        }
                      }}
                    />
                  </div>
                  <hr style={{ opacity: '0.3' }} />
                </div>
              ))}

            <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] items-center">
                <LabelLink
                  href={authInfo?.isPremium || isPremium ? '/my-portfolios' : '/my-followings'}
                  label={authInfo?.isPremium || isPremium ? 'My Portfolios' : 'Followed Solutions'}
                  className="text-[white] font-secondary text-[0.875rem]"
                />
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div>
            <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] items-center">
                <LabelLink
                  href="/my-following-subtopics"
                  label="Followed Categories"
                  className="text-[white] font-secondary text-[0.875rem]"
                />
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div>
            {authInfo.isVendor && (authInfo.isPremium || isPremium || isEnhanced) && isResourceExist && (
              <div className="flex flex-col w-full">
                <div className="flex flex-row h-[2.5rem] items-center">
                  <LabelLink
                    href="/my-resources"
                    label="My Resources"
                    className="text-[white] font-secondary text-[0.875rem]"
                  />
                </div>
                <hr style={{ opacity: '0.3' }} />
              </div>
            )}
            {authInfo.isVendor && !(isPremium || isEnhanced) && isSharedResourceExist && (
              <div className="flex flex-col w-full">
                <div className="flex flex-row h-[2.5rem] items-center">
                  <LabelLink
                    href="/user-resources"
                    label="My Resources"
                    className="text-[white] font-secondary text-[0.875rem]"
                  />
                </div>
                <hr style={{ opacity: '0.3' }} />
              </div>
            )}
            {!authInfo.isVendor && isSharedResourceExist && (
              <div className="flex flex-col w-full">
                <div className="flex flex-row h-[2.5rem] items-center">
                  <LabelLink
                    href="/user-resources"
                    label="My Resources"
                    className="text-[white] font-secondary text-[0.875rem]"
                  />
                </div>
                <hr style={{ opacity: '0.3' }} />
              </div>
            )}
            <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] items-center">
                <LabelLink
                  href="/my-account"
                  label="My Profile"
                  className="text-[white] font-secondary text-[0.875rem]"
                />
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div>
            {/* <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] items-center">
                <LabelLink
                  href="/my-reviews"
                  label="My reviews"
                  className="text-[white] font-secondary text-[0.875rem]"
                />
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div> */}
            <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] items-center">
                <div className="text-[white] font-secondary text-[0.875rem]" onClick={handleSignoutAndRedirect}>
                  Sign Out
                </div>
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div>
          </div>
        )}
        {selectedMenu === 'Industry Analysis' && (
          <div style={{ backgroundColor: '#011d58' }}>
            <div className="flex flex-row">
              <div className="flex flex-col">
                <div className="flex flex-row items-center" onClick={handleMenuBack}>
                  <IonIcon name="chevron-back-outline" className="!w-[20px] !h-[20px] text-[white]" />
                  <p className="text-[white] font-secondary text-[0.75rem] cursor-pointer">Back</p>
                </div>
                <p className="text-[white] font-secondary font-bold text-[0.875rem] mt-[1.2875rem]">
                  INDUSTRY ANALYSIS
                </p>
              </div>

              <div className="flex ml-auto" onClick={handleClosePanel}>
                <IonIcon name="close-outline" className="!h-[30px] !w-[30px] text-[white] cursor-pointer" />
              </div>
            </div>

            <hr className="mt-[0.87652rem]" style={{ opacity: '0.3' }} />

            <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] items-center">
                <LabelLink
                  href="/graveyard-consolidations/?tab=consolidations/"
                  label="Consolidations"
                  className="text-[white] font-secondary text-[0.875rem]"
                  onClick={handleClick}
                />
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div>
            <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] items-center">
                <LabelLink
                  href="/graveyard-consolidations/?tab=graveyard"
                  label="Graveyard"
                  className="text-[white] font-secondary text-[0.875rem]"
                  onClick={handleClick}
                />
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div>

            {/* <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] items-center">
                <LabelLink href="/blogs/" label="Blogs" className="text-[white] font-secondary text-[0.875rem]" />
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div>
            <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] items-center">
                <LabelLink
                  href="/solution-guides/"
                  label="Solution Guides"
                  className="text-[white] font-secondary text-[0.875rem]"
                />
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div>
            <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] items-center">
                <LabelLink href="/know-how" label="Know-How" className="text-[white] font-secondary text-[0.875rem]" />
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div>
            <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] items-center">
                <LabelLink
                  href="/legaltech-resources-for-lawyers/"
                  label="Legaltech Resources for Lawyers"
                  className="text-[white] font-secondary text-[0.875rem]"
                />
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div> */}
            {/* <div className="flex flex-col w-full">
              <div className="flex flex-row h-[2.5rem] cursor-pointer items-center">
                <LabelLink
                  href="/graveyard-consolidations/"
                  label="Graveyard & Consolidations"
                  className="text-[white] font-secondary text-[0.875rem]"
                />
              </div>
              <hr style={{ opacity: '0.3' }} />
            </div> */}
          </div>
        )}
      </div>
      {/* Remove PremiumModal from here - it will be rendered in Header */}
      {/* {showVendorState && (
        <VendorState
          isOpen={showVendorState}
          onClose={() => {
            setShowVendorState(false)
          }}
          vendorName={authInfo.vendor || null}
        />
      )} */}
    </div>
  )
}
